import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { BeforeAfterCarousel } from './components/BeforeAfterCarousel';
import { PainBlock } from './components/PainBlock';
import { TomosGrid } from './components/TomosGrid';
import { BonosSection } from './components/BonosSection';
import { Timer } from './components/Timer';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { VideoTestimonials } from './components/VideoTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfNotHaving } from './components/CostOfNotHaving';
import { FinalCTA } from './components/FinalCTA';
import { SellosBar } from './components/SellosBar';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-base text-brand-cream font-sans selection:bg-brand-green selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBar data-id="element-3" />
      <BeforeAfterCarousel data-id="element-4" />
      <PainBlock data-id="element-5" />
      <TomosGrid data-id="element-6" />
      <BonosSection data-id="element-7" />
      <Timer data-id="element-8" />
      <PricingCards data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <VideoTestimonials data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <CostOfNotHaving data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <SellosBar data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}